import _get from 'lodash/get';

export const INSTRUCTOR_PHOTO_MAX_BYTES = Math.floor((1.5 * 1024 * 1024) / 1.37);

export const isPermissionDenied = ({ response }) => response?.status === 403;

export const isPhotoTooLarge = ({ response }) => response?.status === 413;

export const isUnsupportedMediaType = ({ response }) => response?.status === 415;

export const isClientValidationError = ({ response }) => response?.status === 400;

export const isMsInventoryFormValidationError = ({ response }) =>
  _get(response, 'data.error.key') === 'INVALID_FORM_DATA' || Boolean(_get(response, 'data.form_fields_errors'));

export const getMsInventoryErrorDetail = ({ response }) =>
  _get(response, 'data.detail') ||
  _get(response, 'data.msg') ||
  _get(response, 'data.error.message') ||
  _get(response, 'data.message');

export const instructorPhotoExceedsMaxSize = picture =>
  picture?.length > 0 && picture[0].size > INSTRUCTOR_PHOTO_MAX_BYTES;
